/**
 * XNGAGE CONFIDENTIAL
 * __________________________
 *
 * Copyright (C) 2020 Xngage - All Rights Reserved
 *
 * All code or information contained herein is, and remains the
 * property of Xngage LLC and its customers. The intellectual
 * and technical concepts contained are proprietary to Xngage LLC
 * and may be covered by U.S. and Foreign Patents, patents in
 * process, and are protected by trade secret or copyright law.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Xngage LLC.
 */

import { updateCartLinesCustomProperties } from "@eisinc/App/Services/updateCartCustomProperties";
import { createHandlerChainRunner, Handler, HasOnSuccess } from "@insite/client-framework/HandlerCreator";
import { updateCartWithResult } from "@insite/client-framework/Services/CartService";
import { getCurrentCartState } from "@insite/client-framework/Store/Data/Carts/CartsSelector";
import loadCurrentCart from "@insite/client-framework/Store/Data/Carts/Handlers/LoadCurrentCart";

type Parameter = HasOnSuccess<any> & {
    eisCertificate?: boolean;
    mfrCertificate?: boolean;
    ids?: string[];
};

type HandlerType = Handler<Parameter, any>;

export const PopulateApiParameter: HandlerType = props => {
    const cartState = getCurrentCartState(props.getState()).value;
    if (!cartState) {
        throw new Error("There was no current cart while trying to update the current cart.");
    }
    // eslint-disable-next-line prefer-const
    let ids: string[] = [];
    cartState.cartLines?.forEach(line => ids.push(line.id));

    props.apiParameter = {
        ids,
        eisgcgCertification: props.parameter.eisCertificate,
        mfrCertification: props.parameter.mfrCertificate,
    };
};

export const UpdateCart: HandlerType = async props => {
    const result = await updateCartLinesCustomProperties(props.apiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        props.parameter.onError?.(result.errorMessage);
        return false;
    }
};

export const LoadCart: HandlerType = props => {
    props.dispatch(loadCurrentCart());
};

export const chain = [PopulateApiParameter, UpdateCart, LoadCart];
const SetAllCartLinesCertificate = createHandlerChainRunner(chain, "setAllCartLinesCertificate");

export default SetAllCartLinesCertificate;
